module.exports = __webpack_public_path__ + "static/VTFMisterPixel-Tools-db02c842ac14dc40c33f6c019e94e36b.ttf";